// Service Worker Registration for PWA

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[PWA] Service Worker registered:', registration.scope);

          // Check for updates periodically
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New content available, show update prompt
                  console.log('[PWA] New content available, refresh to update');
                  
                  // Dispatch custom event for UI to handle
                  window.dispatchEvent(new CustomEvent('sw-update-available'));
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('[PWA] Service Worker registration failed:', error);
        });

      // Handle controller change (when new SW takes over)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('[PWA] New Service Worker activated');
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Service Worker unregistration failed:', error);
      });
  }
}

// Check if app is installed as PWA
export function isInstalled() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

// Prompt user to install PWA
export function promptInstall() {
  return new Promise((resolve, reject) => {
    if (!window.deferredPrompt) {
      reject(new Error('Install prompt not available'));
      return;
    }

    window.deferredPrompt.prompt();
    window.deferredPrompt.userChoice.then((choice) => {
      if (choice.outcome === 'accepted') {
        console.log('[PWA] User accepted install prompt');
        resolve(true);
      } else {
        console.log('[PWA] User dismissed install prompt');
        resolve(false);
      }
      window.deferredPrompt = null;
    });
  });
}

// Store the install prompt event
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  console.log('[PWA] Install prompt available');
  
  // Dispatch custom event for UI to handle
  window.dispatchEvent(new CustomEvent('sw-install-available'));
});

// Track successful installation
window.addEventListener('appinstalled', () => {
  console.log('[PWA] App was installed');
  window.deferredPrompt = null;
  
  // Dispatch custom event for UI to handle
  window.dispatchEvent(new CustomEvent('sw-installed'));
});
